import $ from 'jquery';
import AOS from 'aos';
import 'aos/dist/aos.css';

const aosAnim = (() => {
  const defaultAos = () => {
    AOS.init();
  };

  const birdAnim = () => {
    // $(".home-line-animation").clone().prependTo(".main-wrapper");
    // $(".wsm-container .home-line-animation").remove();


    const $window = $(window);
    const $scrollable = $(window);
    const $lineActive = $(".home-line-animation");

    $window.on("scroll", function(){
      const viewportHeight = $window.height() / 4;
      const scrollTop = $scrollable.scrollTop();
      if(scrollTop >= viewportHeight){
        $lineActive.addClass("is-active");
      }
    });
  };


  const svgAnimMap = () => {
    $(document).scroll(function(e){
      // console.log($(".dmt-svg-anim").offset().top)
      $(".dmt-svg-anim").each(function(){
        if($(this).offset().top - 500 <= document.documentElement.scrollTop){
          $(this).addClass("active");
        }
      });
    });
  };

  const init = () => {
    defaultAos();
    birdAnim();
    svgAnimMap();
  };

  return {
    init,
  };
})();

export default aosAnim;
